import { lazy } from "react";

export const MatxLayouts = { layout1: lazy(() => import("./Layout1/Layout1")) };
export const MatxLayoutsOther = { layout1: lazy(() => import("./Layout2/Layout1")) };
